import React, { useState } from "react";
import "../Styles/BookingForm.css";

const BookingForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    date: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Booking submitted:", formData);
    fetch("http://localhost:5000/send-email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) alert("Booking email sent!");
        else alert("Failed to send email.");
      })
      .catch((err) => console.error("Error:", err));
  };

  return (
    <div className="booking-container">
      <form onSubmit={handleSubmit} className="booking-form">
        <div className="name-fields" style={{ display: "flex", gap: "1rem" }}>
          <div style={{ flex: 1 }}>
            <label htmlFor="firstName">First Name</label>
            <input
              id="firstName"
              type="text"
              name="firstName"
              placeholder="First name"
              onChange={handleChange}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label htmlFor="lastName">Last Name</label>
            <input
              id="lastName"
              type="text"
              name="lastName"
              placeholder="Last name"
              onChange={handleChange}
            />
          </div>
        </div>

        <div>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            name="email"
            placeholder="you@company.com"
            onChange={handleChange}
          />
        </div>

        <div className="phone-select" style={{ display: "flex", gap: "1rem" }}>
          <div style={{ width: "25%" }}>
            <label htmlFor="countryCode">Country</label>
            <select
              id="countryCode"
              name="countryCode"
              onChange={handleChange}
              style={{ width: "100%" }}
            >
              <option value="US">US</option>
              <option value="IN">IN</option>
              <option value="UK">UK</option>
            </select>
          </div>
          <div style={{ width: "75%" }}>
            <label htmlFor="phone">Phone</label>
            <input
              id="phone"
              type="tel"
              name="phone"
              placeholder="+1 (555) 000-0000"
              onChange={handleChange}
              style={{ width: "100%" }}
            />
          </div>
        </div>

        <div>
          <label htmlFor="date">Date</label>
          <input id="date" type="date" name="date" onChange={handleChange} />
        </div>

        <div>
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            placeholder="Message"
            onChange={handleChange}
          ></textarea>
        </div>

        <button type="submit">Book an appointment</button>
      </form>
    </div>
  );
};

export default BookingForm;
